import React, { Component } from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";

import { debounce } from "lodash";

import NavigationBar from "../components/NavigationBar";
import Banner from "../components/Banner";

import SpotlightWrapper from "../components/SpotlightWrapper";
import Spotlight from "../components/Spotlight";
import Content from "../components/Content";
import SpecialLink from "../components/SpecialLink";

class IndexPage extends Component {
  state = {
    isScrolled: false,
    isMounted: false
  };

  constructor(props) {
    super(props);
  }

  bannerRef = React.createRef();

  scrollListener = debounce(() => {
    const { clientHeight } = this.bannerRef.current;
    if (window.scrollY >= clientHeight) this.setState({ isScrolled: true });
    else this.setState({ isScrolled: false });
  }, 66);

  componentDidMount() {
    window.addEventListener("scroll", this.scrollListener);

    // trigger banner animation
    setTimeout(() => {
      this.setState({ isMounted: true });
    }, 50);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListener);
  }

  render() {
    const { data, openMenu, langs, language } = this.props;
    return (
      <div className={this.state.isMounted ? "" : "is-preload"}>
        <NavigationBar
          siteTitle={data.site.siteMetadata.title}
          openMenu={openMenu}
          langs={langs}
          language={language}
          className={this.state.isScrolled ? "" : "alt"}
        />
        <Banner
          siteTitle={data.site.siteMetadata.title}
          ref={this.bannerRef}
          language={this.props.pathContext.langKey}
        />
        <SpotlightWrapper>
          <Spotlight>
            <Link to="/es/Consulting" className="image">
              <Img sizes={data.consulting01.childImageSharp.sizes} />
            </Link>
            <Content>
              <h2 className="major">Consulting</h2>
              <p>
                Nuestros servicios de organización y talento laboral ayudan a
                las organizaciones a incrementar su productividad y a agregar
                valor tanto en el mercado como con sus accionistas e inversores.
              </p>
              <SpecialLink to="Consulting">Ver más</SpecialLink>
            </Content>
          </Spotlight>

          <Spotlight>
            <Link to="Services" className="image">
              <Img sizes={data.sindicatos02.childImageSharp.sizes} />
            </Link>
            <Content>
              <h2 className="major">Servicios a sindicatos y Obras Sociales</h2>
              <p>
                Hace más de 7 años brindamos soluciones y servicios a Sindicatos
                y Obras Sociales. Poseemos 3 productos principales para
                administrar y gestionar todo lo relacionado a los afiliados,
                afiliaciones, recaudaciones de los sindicatos y recaudaciones de
                la AFIP u Obra Social, entre otras cosas.
              </p>
              <SpecialLink to="Services">Ver más</SpecialLink>
            </Content>
          </Spotlight>

          <Spotlight>
            <Link to="Outsourcing" className="image">
              <Img sizes={data.outsourcing03.childImageSharp.sizes} />
            </Link>
            <Content>
              <h2 className="major">Outsourcing</h2>
              <p>
                En Ewwo contamos con servicios de outsourcing que incluye la
                contratación de servicios de operaciones, tareas y
                procedimientos funcionales específicos para un proveedor
                tercerizado.
              </p>
              <SpecialLink to="Outsourcing">Ver más</SpecialLink>
            </Content>
          </Spotlight>
        </SpotlightWrapper>
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.es.js